<template>
  <detail envName="种植环境"
    :envInfoType='1' />
</template>

<script>
import Detail from '@/components/business/traceinfo/detail'
export default {
  name: 'plat-env-detail',
  components: { Detail },
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {},
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
